/**
 *  Main navigation
 */

const $navToggle = document.querySelectorAll('.js-nav-toggle')[0];
const $navigation = document.querySelectorAll('.nav-main')[0];
const $body = document.querySelectorAll('body')[0];

const clickEvent = ((document.ontouchstart !== null) ? 'click' : 'touchstart');

if ($navToggle) {
    $navToggle.addEventListener(clickEvent, (e) => {
        e.preventDefault();
        e.stopPropagation();
        $navToggle.classList.toggle('open');
        $navigation.classList.toggle('is-open');
        $body.classList.toggle('-menu-open');
    });

    $body.addEventListener(clickEvent, (e) => {
        if ($body.classList.contains('-menu-open')) {
            if (!$navigation.contains(e.target)) {
                e.preventDefault();
                e.stopPropagation();
                $navToggle.classList.remove('open');
                $navigation.classList.remove('is-open');
                $body.classList.remove('-menu-open');
            }
        }
    });
}
